import type { AddinViewState } from "owa-editor-addin-plugin-types/lib/utils/AddinViewState";
import { mutatorAction } from "satcheljs";

const setIsOnSendEventTriggeredMutator: (viewState: AddinViewState, isTrigerred: boolean) => void = mutatorAction("isOnSendEventTriggered", (viewState: AddinViewState, isTrigerred: boolean): void => {
    viewState.isOnSendEventTriggered = isTrigerred;
});
export default setIsOnSendEventTriggeredMutator;
